import * as React from "react";
import { NavLink } from "react-router-dom";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    IconButton,
    TableCell,
    Typography
} from "@mui/material";
import { Close, Delete, Edit, History, ContentCopy } from "@mui/icons-material";
import { translate } from "../../translate/translate";


interface TableMenuProps {
    row: any;
    handleOpenDialogHistory: (id: number) => void;
    editWithDialog?: (row: any) => void;
    handleDelete: (row: any) => void;
    showActions?: string[];
    handleDuplicate?: (row: any) => void;
    canDelete?: boolean;
}

const TableMenuComponent: React.FC<TableMenuProps> = ({
    row,
    handleOpenDialogHistory,
    editWithDialog,
    handleDelete,
    showActions,
    handleDuplicate,
    canDelete=false
}) => {
    
    const [open, setOpen] = React.useState(false);
    
    const handleOpenDialog = () => {
        setOpen(true);
    };

    const handleCloseDialog = () => {
        setOpen(false);
    };

    return (
        <>
            <TableCell align="right">
                <Box display="flex" gap={1} justifyContent="center" alignItems="center" >
                    {(!showActions || showActions.includes("history")) && (
                        <IconButton
                            sx={{ color: "#546E7A" }}
                            size="small"
                            onClick={() => handleOpenDialogHistory(row.id)}
                        >
                            <History />
                        </IconButton>
                    )}

                    {(!showActions || showActions.includes("edit")) && (
                        <IconButton
                            component={NavLink}
                            to={`${row.id}`}
                            sx={{ color: "#546E7A" }}
                            size="small"
                            onClick={() => {
                                if (editWithDialog) editWithDialog(row);
                            }}
                        >
                            <Edit />
                        </IconButton>
                    )}

                    {(!showActions || showActions.includes("delete")) && (
                        <IconButton
                            sx={{ color: "#546E7A" }}
                            size="small"
                            onClick={() => { handleOpenDialog(); }}
                            disabled={canDelete}
                        >
                            <Delete />
                        </IconButton>
                    )}

                    {showActions && showActions.includes("duplicate") && (
                        <IconButton
                            sx={{ color: "#546E7A" }}
                            size="small"
                            onClick={() => {
                                handleDuplicate && handleDuplicate(row);
                            }}
                        >
                            <ContentCopy />
                        </IconButton>
                    )}
                </Box>
            </TableCell>

            <Dialog open={open} onClose={handleCloseDialog}>
                <Grid padding={2} container justifyContent="space-between" sx={{ backgroundColor: "primary.main" }}>
                    <Grid item>
                        <Typography sx={{ color: "#ffffff", fontWeight: "bold", fontSize: "16px" }}>
                            {translate.t("delete")}
                        </Typography>
                    </Grid>
                    <Grid item sx={{ cursor: "pointer", color: "#ffffff" }}>
                        <Close onClick={() => {
                            handleCloseDialog();
                        }} />
                    </Grid>
                </Grid>
                <DialogContent>
                    <Grid container flexDirection="column" gap={1}>
                        <Grid item>
                            <Typography>
                                {translate.t("confirm_delete")}
                            </Typography>
                        </Grid>
                        {
                            row.name !== undefined && (
                                <Grid item>
                                    <Typography sx={{ fontWeight: "bold" }}>
                                        {row.name}
                                    </Typography>
                                </Grid>
                            )
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="flex-end" gap={1} padding={2}>
                        <Grid item>
                            <Button
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    handleCloseDialog();
                                }}>{translate.t("cancel")}</Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => {
                                    handleDelete(row);
                                    handleCloseDialog();
                                }}>{translate.t("delete")}</Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default TableMenuComponent;
